import { getTeamLeagueSeasonsUseCase } from '@/domain/use-cases/get-team-league-seasons.use-case';
import { Result } from '@/entities/Result';
import { SeasonListItem } from '@/entities/SeasonList';

export const getSeasonsListController = async (organizationUuid: string, teamLeagueUuid: string): Promise<Result<SeasonListItem[]>> => {
	return getTeamLeagueSeasonsUseCase(organizationUuid, teamLeagueUuid);
};
